import { mapGetters } from 'vuex'
import { playtimeFilter } from '../utils/filters'

const dummy = (home, away) => `${home}-${away}`

export default {
  data () {
    return {
      eventsWithScore: ['SET', 'CANCEL', 'ADJUST_SCORE'],
      betstopEvents: ['BETSTOP', 'BETSTART'],
      numberOfPlayersChangeEvents: [
        '2_MIN_PENALTY',
        '2_AND_2_MIN_PENALTY',
        '5_MIN_PENALTY',
        '5_AND_2_MIN_PENALTY',
        'PLAYER_ON_PITCH'
      ]
    }
  },
  methods: {
    getEventTimer ({ Playtime }, { delta }) {
      return playtimeFilter(Playtime + delta * 1000)
    },
    getEventCustomSound (event, relatedEvent) {
      if (!event) {
        return
      }

      const { EventCode } = event
      const { sport } = this
      const { methods } = sport
      const { eventSounds } = methods

      if (!eventSounds || !eventSounds.hasOwnProperty(EventCode)) return

      return eventSounds[EventCode].bind(this)(event, relatedEvent)
    },
    getEventCustomClass (event, relatedEvent) {
      if (!event) {
        return
      }

      const { EventCode } = event
      const { sport } = this
      const { methods } = sport
      const { eventClasses } = methods

      if (!eventClasses) return ''

      if (!eventClasses.hasOwnProperty(EventCode)) return ''

      return eventClasses[EventCode].bind(this)(event, relatedEvent)
    },
    getEventCounters (event, relatedEvent) {
      if (!event) {
        return
      }

      if (event.EventCode === 'SET' && event.extra && event.extra.hasOwnProperty('sets-1')) {
        return { score: `${event.extra['sets-1']}-${event.extra['sets-2']}` }
      }

      if (event.EventCode === 'POSSIBLE_GOAL' && event.extra && event.extra.futureScore) {
        return { score: event.extra.futureScore }
      }
      const score = this.getEventScore(event, relatedEvent)

      if (score) return { score }

      const sets = this.getEventSets(event, relatedEvent)

      if (sets) return { score: sets }

      const fouls = this.getEventFouls(event, relatedEvent)

      if (fouls) return { fouls }

      return {}
    },
    getEventSets (event, relatedEvent) {
      if (!event) {
        return
      }

      const { EventCode, ScoreHome, ScoreAway } = event
      const { cachedActionTypes, getSettings } = this
      const { needToShowSets } = getSettings

      if (cachedActionTypes[EventCode] === 'set' && needToShowSets) return `${ScoreHome}-${ScoreAway}`

      if (EventCode === 'CANCEL' && cachedActionTypes[relatedEvent.EventCode] === 'set' && needToShowSets) return `${ScoreHome}-${ScoreAway}`
    },
    getEventFouls (event, relatedEvent) {
      if (!event) {
        return
      }

      const { EventCode, extra } = event
      const { cachedActionTypes } = this

      if (
        (
          EventCode === 'DELAYED_FOUL' ||
          EventCode === 'FOUL' ||
          EventCode === 'ADJUST_FOULS' ||
          cachedActionTypes[EventCode] === 'foul' ||
          (
            EventCode === 'CANCEL' &&
            (
              relatedEvent.EventCode === 'DELAYED_FOUL' ||
              relatedEvent.EventCode === 'FOUL' ||
              cachedActionTypes[relatedEvent.EventCode] === 'foul'
            )
          )
        ) &&
        extra.hasOwnProperty('fouls-1') &&
        extra.hasOwnProperty('fouls-2')
      ) {
        return `${extra['fouls-1']}-${extra['fouls-2']}`
      }
    },
    getEventScore (event, relatedEvent) {
      if (!event) {
        return
      }

      const { EventCode, ScoreHome, ScoreAway, extra } = event
      const { cachedActionTypes, eventsWithScore, getSettings } = this
      const { scoreInPoints } = getSettings
      const { sport: { methods: { eventCounters } } } = this
      const byCode = eventCounters ? eventCounters[EventCode] : null
      const byType = eventCounters && cachedActionTypes[EventCode] ? eventCounters[cachedActionTypes[EventCode]] : null
      const scoreFn =
        byCode ||
        byType ||
        dummy

      if (EventCode === 'CANCEL' && relatedEvent && cachedActionTypes[relatedEvent.EventCode] !== 'score') return ''

      if (EventCode === 'ADJUST_SETS') return scoreFn(ScoreHome, ScoreAway)

      if (cachedActionTypes[EventCode] !== 'score' && !eventsWithScore.includes(EventCode)) return ''

      if (scoreInPoints) {
        return scoreFn(extra['points-1_byPeriod'] || extra['points-1'], extra['points-2_byPeriod'] || extra['points-2'])
      }

      if (extra && (Number(extra.shootout1) || Number(extra.shootout2))) {
        return scoreFn(extra.shootout1, extra.shootout2)
      }

      return scoreFn(ScoreHome, ScoreAway)
    },
    getEventTitle (event, relatedEvent) {
      if (!event) {
        return
      }

      const {
        numberOfPlayersChangeEvents,
        betstopEvents,
        homeTeamTitle,
        awayTeamTitle
      } = this
      const {
        EventCode,
        eventInfo,
        RelatedEventNumber,
        TeamNumber,
        extra
      } = event
      let relEvent = relatedEvent

      if (!relEvent && RelatedEventNumber) relEvent = this.getRelatedEvent(RelatedEventNumber)

      const { title } = eventInfo

      const customSportTitle = this.getCustomSportTitle(EventCode)

      if (customSportTitle) return customSportTitle(event, relEvent)

      if (title.includes('{')) return this.getTemplateTitle(title, event)

      const titleByEventCode = this.getTitleByEventCode(event, relEvent)

      if (titleByEventCode) return titleByEventCode

      const isBetStop = betstopEvents.includes(EventCode)
      const squadChanges = numberOfPlayersChangeEvents.includes(EventCode)

      if (TeamNumber && !isBetStop) {
        const teamTitle = TeamNumber === 1 ? homeTeamTitle : awayTeamTitle
        let titleTemp = `${title} / ${teamTitle}`

        if (squadChanges) {
          titleTemp += ` (${extra['team1']}x${extra['team2']})`
        }

        return titleTemp
      }

      if (EventCode === 'APP_STOP' && extra.app_stop_cause) {
        return `${title} / ${this.$t(`app_stop_cause.${extra.app_stop_cause}`)}`
      }

      return title
    },
    getTitleByEventCode (event, relatedEvent) {
      if (!event) {
        return
      }

      const { EventCode, eventInfo, extra } = event
      const { title } = eventInfo

      switch (EventCode) {
        case 'MATCH_FORMAT': return this.matchFormatTitle(event)
        case 'POSSIBLE_PLAYER_CHANGE':
          return `${title} ${extra['team']}`
        case 'GAME_START_DELAYED':
          return `${title} ${extra.minutes ? `(${extra.minutes} min)` : ''}`
        case 'ADDITIONAL_TIME':
          const COUNT = extra.minutes

          return `${title} (${COUNT} ${this.$tc('minutes', COUNT)})`
        case 'ADJUST_EVENT_TIME':
          // TODO реализовать потом
          return `${title}: ${this.getEventTitle(relatedEvent)}, ${this.getEventTimer(relatedEvent, extra)}`
        case 'CANCEL':
          return `${title}: ${this.getEventTitle(relatedEvent)}`
      }
    },
    matchFormatTitle (event) {
      if (!event) {
        return
      }

      const { extra, eventInfo } = event

      if (!extra) return eventInfo.title

      const { comment, overtimeFormat, weight_class: weightClass } = extra
      let title = `${this.$t('matchFormat')}: ${extra.matchFormat && extra.matchFormat.name}`

      if (overtimeFormat) {
        title += `<br>${this.$t('overtimeFormat')}: ${overtimeFormat.name}`
      }

      if (comment) {
        title += `<br>(${this.$t('comment', { comment: comment.replace(/\n/g, '<br>') })})`
      }

      if (weightClass) {
        title += `<br>${this.$t('weightClass', { weightClass: weightClass.replace(/\n/g, '<br>') })}`
      }

      return title
    },
    getCustomSportTitle (eventCode) {
      const { sport } = this
      const { methods } = sport
      const { eventTitles } = methods

      if (!eventTitles) return

      if (eventTitles.hasOwnProperty(eventCode)) return eventTitles[eventCode].bind(this)

      return false
    },
    getTemplateTitle (title, event) {
      // eslint-disable-next-line no-console
      console.log('template title')

      return title

      // _.templateSettings.interpolate = /{([\s\S]+?)}/g
      //
      // return _.template(title)(event)
    }
  }
}
